import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { logout, reset } from '../features/auth/authSlice';
import { subscriptionSlice } from '../features/subscription/subscriptionSlice';

// Centralised employer logout.
// Navigates first so Homedash unmounts before state.user is set to null,
// preventing "Cannot read properties of null" crashes on user.company etc.
const useLogout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return useCallback(() => {
        navigate('/login');
        dispatch(subscriptionSlice.actions.reset());
        dispatch(logout());
        dispatch(reset());
    }, [dispatch, navigate]);
};

export default useLogout;
